function miseAJourPanier() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const totalPrice = data.total_price / 100;  // Convertir en euros
      const itemCount = data.item_count;

      // Mise à jour du total dans le drawer
      document.querySelector("#total-price").textContent = `${totalPrice}€`;  // Assurez-vous que cet ID existe dans votre HTML
      document.querySelector("#item-count").textContent = `${itemCount} articles`;  // Mettre à jour le nombre d'articles
    })
    .catch(error => console.error('Erreur lors de la mise à jour du panier:', error));
}
